import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from '@intranet/components/tooltip/tooltip.module';
import { TimerStartButtonComponent } from './timer-start-button.component';

@NgModule({
    declarations: [TimerStartButtonComponent],
    imports: [CommonModule, MatIconModule, TooltipModule],
    exports: [TimerStartButtonComponent],
})
export class TimerStartButtonModule {}
